import { MapaPeligroState } from '@/store/modules/mapa-peligro/types'
import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { getters } from '@/store/modules/mapa-peligro/getters'
import { actions } from '@/store/modules/mapa-peligro/actions'
import { mutations } from '@/store/modules/mapa-peligro/mutations'

export const state: MapaPeligroState = {
  error: { state: false },
  mapasPeligro: []
}

const namespaced: boolean = true

export const mapaPeligro: Module<MapaPeligroState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
